import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { TP_COLORS } from '../../../../constants';
import { useAppSelector } from '../../../../hooks';
import { getSubTopicState } from '../../../../store/SubTopicSlice';

interface ISessionStudents {
  handleButtonClick: () => void;
}

const AttemptQuizBar: React.FC<ISessionStudents> = ({ handleButtonClick }) => {
  // Store
  const subTopicState = useAppSelector(getSubTopicState);

  const { subTopic } = subTopicState;

  return subTopic && subTopic.quizCount && subTopic.quizCount > 0 ? (
    <Box
      sx={{
        height: { xs: '84px', sm: '50px' },
        display: 'flex',
        alignItems: 'center',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: { xs: 'space-evenly', sm: 'center' },
        position: 'sticky',
        top: { xs: '56px', sm: '64px' },
        zIndex: 5,
        background: {
          xs: `url('${process.env.PUBLIC_URL}/images/subtopicPage/shape-quiz-header-1.png') top left/cover no-repeat, ${TP_COLORS.blue.dark}`,
          sm: `url('${process.env.PUBLIC_URL}/images/subtopicPage/shape-quiz-header-1.png') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/subtopicPage/shape-quiz-header-2.png') top right/contain no-repeat, ${TP_COLORS.blue.dark}`,
        },
      }}
    >
      <Typography variant="subtitle1" color={TP_COLORS.white}>
        Let’s take a Quiz{' '}
        {subTopic && subTopic.name ? `on ${subTopic.name}` : ''}
      </Typography>
      <Button
        size="small"
        color="inherit"
        variant="contained"
        sx={{
          color: TP_COLORS.black,
          backgroundColor: TP_COLORS.white,
          fontWeight: '600',
          marginLeft: '20px',
        }}
        onClick={handleButtonClick}
      >
        Attempt a Quiz
      </Button>
    </Box>
  ) : null;
};

export default AttemptQuizBar;
